module.exports = __webpack_public_path__ + "public/img/tada.68e53a4.png";